import { render, staticRenderFns } from "./matchVariables.vue?vue&type=template&id=fc37ed4e"
import script from "./matchVariables.vue?vue&type=script&lang=js"
export * from "./matchVariables.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports